/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ObservationOverview
 */
export interface ObservationOverview {
  /**
   *
   * @type {string}
   * @memberof ObservationOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof ObservationOverview
   */
  observationType?: string | null;
  /**
   *
   * @type {string}
   * @memberof ObservationOverview
   */
  validationStatus?: string | null;
  /**
   *
   * @type {Date}
   * @memberof ObservationOverview
   */
  beginPosition: Date;
  /**
   *
   * @type {Date}
   * @memberof ObservationOverview
   */
  endPosition: Date;
  /**
   *
   * @type {string}
   * @memberof ObservationOverview
   */
  measurementInstrumentType?: string | null;
}

/**
 * Check if a given object implements the ObservationOverview interface.
 */
export function instanceOfObservationOverview(value: object): value is ObservationOverview {
  if (
    (!("beginPosition" in (value as Record<string, any>)) &&
      !("begin_position" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["beginPosition"] === undefined &&
      (value as Record<string, any>)["begin_position"] === undefined)
  )
    return false;
  if (
    (!("endPosition" in (value as Record<string, any>)) &&
      !("end_position" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endPosition"] === undefined &&
      (value as Record<string, any>)["end_position"] === undefined)
  )
    return false;
  return true;
}

export function ObservationOverviewFromJSON(json: any): ObservationOverview {
  return ObservationOverviewFromJSONTyped(json, false);
}

export function ObservationOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ObservationOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    observationType:
      json["observation_type"] === undefined
        ? undefined
        : json["observation_type"] === null
        ? null
        : json["observation_type"],
    validationStatus:
      json["validation_status"] === undefined
        ? undefined
        : json["validation_status"] === null
        ? null
        : json["validation_status"],
    beginPosition: new Date(json["begin_position"]),
    endPosition: new Date(json["end_position"]),
    measurementInstrumentType:
      json["measurement_instrument_type"] === undefined
        ? undefined
        : json["measurement_instrument_type"] === null
        ? null
        : json["measurement_instrument_type"],
  };
}

export function ObservationOverviewToJSON(json: any): ObservationOverview {
  return ObservationOverviewToJSONTyped(json, false);
}

export function ObservationOverviewToJSONTyped(
  value?: Omit<ObservationOverview, "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    observation_type: value["observationType"],
    validation_status: value["validationStatus"],
    begin_position: value["beginPosition"].toISOString().substring(0, 10),
    end_position: value["endPosition"].toISOString().substring(0, 10),
    measurement_instrument_type: value["measurementInstrumentType"],
  };
}
